var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-help"},[_c('p',{staticClass:"sidebar-help-text"},[_vm._v(_vm._s(_vm.info.text)+" "),_c('a',{staticClass:"sidebar-help-text-link",attrs:{"href":_vm.info.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('message.sidebar.message.clickHere')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }